module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM9.02 23.706a.936.936 0 0 1-1.368 0l-1.368-1.434a1.046 1.046 0 0 1 0-1.432l4.646-4.868-4.59-4.81a1.043 1.043 0 0 1 0-1.43l1.368-1.434a.933.933 0 0 1 1.368 0l6.644 6.958a1.05 1.05 0 0 1 0 1.432l-6.7 7.018zm16.698-7.016l-6.7 7.016a.936.936 0 0 1-1.368 0l-1.368-1.434a1.046 1.046 0 0 1 0-1.432l4.646-4.868-4.588-4.81a1.043 1.043 0 0 1 0-1.43l1.368-1.434a.933.933 0 0 1 1.368 0l6.644 6.958a1.05 1.05 0 0 1-.002 1.434z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/fast-forward-1.js
// module id = 1139
// module chunks = 14